import { widget_error, retry } from "@/assets/en.json";
import { WIDGET_ERROR_CLASS } from "@/utils/constants";

// The classic loader cannot depend on React or initialization. Reuse the app's
// English fallback catalog until the backend catalog becomes available.
export const bootstrapWidgetErrorMessages = { ...widget_error, retry };

export interface WidgetErrorDetails {
  message: string;
  retryLabel?: string;
  onRetry?: () => unknown;
  dismissLabel?: string;
  onDismiss?: () => void;
}

export function renderWidgetError(element: HTMLElement, details: WidgetErrorDetails) {
  const alert = document.createElement("div");
  alert.className = WIDGET_ERROR_CLASS;
  alert.setAttribute("role", "alert");
  const message = document.createElement("p");
  message.textContent = details.message;
  alert.append(message);
  if (details.onRetry) {
    const button = document.createElement("button");
    button.type = "button";
    button.textContent = details.retryLabel || bootstrapWidgetErrorMessages.retry;
    button.addEventListener("click", () => details.onRetry?.());
    alert.append(button);
  }
  element.replaceChildren(alert);
}
